export default __webpack_public_path__ + "static/media/Switch_user.e2375dd7.svg";